<template>
  <div class="main container">
    <div class="select-mode container" v-show="step === 1">
      <div class="dialog">
        <div class="btn disabled" title="還沒做><">[匿名聊天]</div>
        <div class="btn" @click="mode = '暱稱聊天'; step = 2">[暱稱聊天]</div>
      </div>
    </div>
    <div class="select-mode container" v-show="step === 2">
      <div class="dialog">
        <div>暱稱聊天</div>
        <div class="input-wrap" :class="{error: nicknameError}">
          <input class="nickname" type="text" name="" id="" v-model="nickname" v-on:keypress.enter="setNickname" v-on:keyup="nicknameError = false" placeholder="輸入暱稱" spellcheck="false">
        </div>
        <!-- <span style="color: red; font-size: 12px;">{{nicknameError}}</span> -->
        <div class="btn" @click="setNickname">[確定]</div>
      </div>
    </div>
    <div class="select-mode container" v-show="step === 3">
      <div class="dialog">
        <div class="btn disabled" title="還沒做><">[隨機配對1對1聊天]</div>
        <div class="btn" @click="enterChatroom">[進入聊天大廳]</div>
      </div>
    </div>
    <div class="chatroom container" v-show="step === 4">
      <!-- <div>uuid: {{uuid}}</div>
      <div>{{channels}}</div> -->
      <div class="left close">
        <div class="group-img">
          <img src="@/assets/images/group.svg" alt="">
        </div>
        <div class="panel-title">聊天大廳</div>
      </div>
      <div class="editor">
        <div class="tabs">
          <div class="tab-1">
            <div class="tab-text">
              聊天室
            </div>
            <div class="tab-close">
              <i class="fas fa-times"></i>
              <!-- <img src="@/assets/images/close.svg" alt=""> -->
            </div>
          </div>
        </div>
        <div class="view">
          <div class="messages" :key="index" v-for="(msg, index) in channels">
            <!-- {{tt}}{{item.text}} -->
            <!-- <link rel="random" href="id22222已進入聊天室"> -->
            <div class="message-block" v-if="msg.uuid === 'system'">
              <span class="timestamp time">{{ msg.timestamp ? msg.timestamp.seconds : '' | timeFormat }}</span>
              <div class="system">
                <span v-if="msg.text !== nickname" :class="{'self-system': msg.text !== nickname}">&lt;!--</span>
                <span class="bracket" :class="{'self-system': msg.text !== nickname}">&lt;</span>
                <span class="tag" :class="{'self-system': msg.text !== nickname}">link&nbsp;</span>
                <span class="property" :class="{'self-system': msg.text !== nickname}">rel</span>
                <span class="text" :class="{'self-system': msg.text !== nickname}">=</span>
                <span class="value" :class="{'self-system': msg.text !== nickname}">"random"&nbsp;</span>
                <span class="property" :class="{'self-system': msg.text !== nickname}">type</span>
                <span class="text" :class="{'self-system': msg.text !== nickname}">=</span>
                <span class="value" :class="{'self-system': msg.text !== nickname}">"{{`system/log`}}"&nbsp;</span>
                <span class="property" :class="{'self-system': msg.text !== nickname}">href</span>
                <span class="text" :class="{'self-system': msg.text !== nickname}">=</span>
                <span class="value" :class="{'self-system': msg.text !== nickname}">"{{`\{${msg.text}\}\/已進入聊天室`}}"&nbsp;</span>
                <span class="bracket" :class="{'self-system': msg.text !== nickname}">/&gt;&nbsp;</span>
                <span v-if="msg.text !== nickname" :class="{'self-system': msg.text !== nickname}">--&gt;</span>
                <!-- <span class="slash">&lt;!-- system log --&gt;</span> -->
              </div>
            </div>
            <div v-else>
              <div class="message-block" v-if="msg.uuid === uuid && msg.nickname === nickname ">
                <span class="timestamp time">{{ msg.timestamp ? msg.timestamp.seconds : '' | timeFormat }}</span>
                <div class="self">
                  <!-- tag start -->
                  <div>
                    <span class="comment">&lt;!-- &lt;</span>
                    <span class="comment">div&nbsp;</span>
                    <span class="comment">id</span>
                    <span class="comment">=</span>
                    <span class="comment">"{{msg.nickname}}"&nbsp;</span>
                    <span class="comment">class</span>
                    <span class="comment">=</span>
                    <span class="comment">"guest"</span>
                    <span class="comment">&gt;</span>
                  </div>
                  <!-- tag inside -->
                  <div class="msg comment" v-for="(m, i) in msg.text" :key="i">
                    {{ m || '&nbsp;' }}
                  </div>
                  <!-- tag close -->
                  <div>
                    <span class="comment">&lt;</span>
                    <span class="comment">/div</span>
                    <span class="comment">&gt; --&gt;</span>
                  </div>
                </div>
              </div>
              <div class="message-block" v-else>
                <span class="timestamp time">{{ msg.timestamp ? msg.timestamp.seconds : '' | timeFormat }}</span>
                <div>
                  <!-- tag start -->
                  <div>
                    <span class="bracket">&lt;</span>
                    <span class="tag">div&nbsp;</span>
                    <span class="property">id</span>
                    <span class="text">=</span>
                    <span class="value">"{{msg.nickname}}"&nbsp;</span>
                    <span class="property">class</span>
                    <span class="text">=</span>
                    <span class="value">"guest"</span>
                    <span class="bracket">&gt;</span>
                  </div>
                  <!-- tag inside -->
                  <div class="msg text" v-for="(m, i) in msg.text" :key="i">
                    {{ m || '&nbsp;' }}
                  </div>
                  <!-- tag close -->
                  <div>
                    <span class="bracket">&lt;</span>
                    <span class="tag">/div</span>
                    <span class="bracket">&gt;</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-area">
          <div class="divider"></div>
          <div class="input-wrap">
            <div class="username">{{nickname}}</div>
            <div class="input-field">
              <textarea
                type="textarea"
                v-model="myMsg"
                spellcheck="false"
                @keypress.enter.exact.prevent="submit"/>
            </div>
          </div>
          <div class="bottom">
            <div class="btn send" @click="submit">傳送 &gt;</div>
          </div>
        </div>
      </div>
      <!-- <input v-model="message" /> <input type='button' @click="send"  value='send'/> -->
    </div>
  </div>
</template>

<script>
import { db } from '@/utils/db'
import firebase from 'firebase/app'
import moment from 'moment'
export default {
  name: 'HelloWorld',
  props: {
    msg: String,
    uuid: String
  },
  filters: {
    timeFormat(timestamp) {
      return timestamp ? moment.unix(timestamp).format('hh:mm') : ''
    }
  },
  data() {
    return {
      step: 1,
      mode: '',
      nickname: '',
      nicknameError: false,
      channel: null,
      channels: [],
      myMsg: ''
    }
  },
  mounted(){
    this.channel = db.collection('chatroom_01')
    // console.log(this.channel.orderBy('timestamp'))
  },
  firestore () {
    return {
      channels: db.collection('chatroom_01').orderBy('timestamp')
    }
  },
  computed:{
  },
  watch: {
    step(step) {
      if(step !== 4) {
        return
      }
      setTimeout(()=>{
        const el = document.querySelector('.view')
        // console.log(el, el.scrollTop, el.scrollHeight)
        // el.scrollTop = el.scrollHeight
        this.scrollTo(el, el.scrollHeight, 500)
      }, 500)
    },
    channels() {
      const el = document.querySelector('.view')
      // console.log(el, el.scrollTop, el.scrollHeight)
      // el.scrollTop = el.scrollHeight
      this.scrollTo(el, el.scrollHeight, 500)
    }
  },
  methods:{
    setNickname() {
      if(this.nickname === '') {
        this.nicknameError = true
        return
      }
      this.step = 3
    },
    scrollTo(element, to, duration) {
      if(duration <= 0) {
        return
      }
      const difference = to - element.scrollTop
      const perTick = difference / duration * 10

      setTimeout(() => {
        element.scrollTop = element.scrollTop + perTick
        if (element.scrollTop === to) {
          return
        }
        this.scrollTo(element, to, duration - 10)
      }, 10)
    },
    submit() {
      if(this.myMsg.replace(/\n/g, '') === '') {
        this.myMsg = `${this.myMsg}\n`
        return
      }
      const timestamp =  firebase.firestore.FieldValue.serverTimestamp()
      const message = this.myMsg.split('\n')

      this.channel.add({
        uuid: this.uuid,
        nickname: this.nickname,
        text: message,
        timestamp: timestamp
      })
      this.myMsg = ''
    },
    newline() {
      // console.log('newline')
      // this.myMsg = `${this.myMsg}`
    },
    enterChatroom() {
      this.step = 4
      const timestamp =  firebase.firestore.FieldValue.serverTimestamp()

      this.channel.add({
        uuid: 'system',
        text: `${this.nickname}`,
        timestamp: timestamp
      })
      this.message =  ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/assets/scss/_flex.scss';
@import '@/assets/scss/_var.scss';
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.container {
  width: 100%;
  height: 100%;
  @extend %flexbox;
  @include justify-content(center);
  @include align-items(center);
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
.dialog {
  width: 250px;
  height: 250px;
  font-size: 20px;
  color: $color-id-1;
  background-color: $bgc-float;
  box-shadow: 0 3px 30px rgba(#000, .2);
  @extend %flexbox;
  @include flex-direction(column);
  @include justify-content(space-evenly);
  @include align-items(center);
  .btn {
    color: $color-text;
    cursor: pointer;
    &:hover {
      color: $color-emoji;
    }
    &.disabled {
      color: $color-time;
      cursor: not-allowed;
    }
  }
  .input-wrap {
    position: relative;
    input {
      background-color: $bgc-float;
      font-size: 16px;
      color: $color-text;
      text-align: center;
      border-bottom: 1px solid #707070;
      &::placeholder {
        font-size: 16px;
        color: #6c6c6c;
        text-align: center;
      }
    }
    &.error:after {
      position: absolute;
      content: '請輸入暱稱';
      color: red;
      font-size: 12px;
      top: 120%;
      left: 0;
    }
  }
}
.chatroom {
  .bracket,
  .time {
    color: $color-time;
  }
  .tag {
    color: $color-tag;
  }
  .property {
    color: $color-property;
  }
  .text {
    color: $color-text;
  }
  .value {
    color: $color-value;
  }
  .comment {
    color: $color-comment;
  }
  .slash {
    color: $color-slash;
  }
}
.chatroom {
  display: grid;
  grid-template-columns: auto 1fr;
  .left {
    width: 300px;
    height: 100%;
    background-color: $bgc-left;
    color: $bgc-text;
    @extend %flexbox;
    @include flex-direction(column);
    transition: width .8s;
    will-change: width;
    &.close {
      width: 50px;
      line-height: 50px;
      @extend %flexbox;
      @include flex-direction(column);
      text-align: left;
      .panel-title {
        font-size: 18px;
        letter-spacing: 5px;
        writing-mode: vertical-lr;
      }
      .group-img {
        width: 30px;
        margin: 0 auto;
        padding: 15px 0;
        img {
          width: 100%;
        }
      }
    }
  }
  .editor {
    height: 100%;
    background-color: $bgc-bg;
    line-height: 28px;
    display: grid;
    grid-template-rows: 50px calc(100vh - 250px) 200px;
    .tabs {
      background-color: $bgc-left;
      div[class^='tab-'] {
        @extend %flexbox;
        @include justify-content(space-between);
        @include align-items(center);
        background-color: $bgc-bg;
        color: $color-text;
        width: 180px;
        line-height: 50px;
        .tab-text {
          padding: 0 20px;
        }
        .tab-close {
          width: 40px;
          // height: 20px;
          // @include align-self(flex-end);
        }
      }
    }
    .view {
      padding: 20px;
      overflow-y: auto;
      .messages {
        @extend %flexbox;
        @include flex-direction(column);
        @include justify-content(flex-start);
        @include align-items(flex-start);
        .message-block {
          @extend %flexbox;
          padding-bottom: 12px;
          text-align: left;
          .timestamp {
            width: 100px;
          }
          .msg {
            margin-left: 24px;
            padding-left: 16px;
            border-left: 1px solid rgba(#D4D4D4, .3);
          }
          .self,
          .system {
            margin-left: 36px;
          }
          .self-system {
            color: $color-slash;
          }
        }
      }
    }
  }
  .text-area {
    display: grid;
    grid-template-rows: 36px 1fr 48px;
    .divider {
      background-color: $bgc-left;
    }
    .input-wrap {
      @extend %flexbox;
      // @include flex-direction(column);
      .username {
        width: 150px;
        padding-left: 10px;
        color: $color-self-text;
        text-align: left;
        word-break: break-all;
        &:after {
          content: ' >';
          color: $color-text;
        }
      }
      .input-field {
        width: calc(100% - 150px);
        padding-left: 10px;
        text-align: left;
        background-color: $bgc-bg;
        box-shadow: 1px -2px 1px $bgc-float inset;
        textarea {
          font-size: 100%;
          line-height: 1.5;
          color: $color-text;
          width: 100%;
          height: 100%;
          background-color: transparent;
          outline: none;
          border: none;
        }
      }
    }
    .bottom {
      @extend %flexbox;
      @include justify-content(flex-end);
      .btn.send {
        @extend %flexbox;
        @include justify-content(center);
        @include align-items(center);
        width: 100px;
        height: 100%;
        color: $color-text;
        letter-spacing: 5px;
        background-color: $bgc-left;
        cursor: pointer;
      }
    }
  }
}
</style>
